import { useEffect } from "react";

import { useState } from "react";
import { PageLoading } from "../../../components/page_loading";
import Grid from "@mui/joy/Grid";
import Typography from "@mui/joy/Typography";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import FormHelperText from "@mui/joy/FormHelperText";
import Switch from "@mui/joy/Switch";

export const RestApiComponent = (props: {
  loading: boolean;
  deploymentId: string;
  restApiStackParamsJson: string | null;
  restApiStackStatus: string | null;
}) => {
  const { loading, restApiStackParamsJson, restApiStackStatus } = props;

  const [fullDomainName, setFullDomainName] = useState<string>("");
  const [backendApiHostname, setBackendApiHostname] = useState<string>("");
  const [excludeStageFromPath, setExcludeStageFromPath] =
    useState<boolean>(false);
  const [genericCertificateArn, setGenericCertificateArn] =
    useState<string>("");
  const [logRetentionDays, setLogRetentionDays] = useState<string>("");

  useEffect(() => {
    if (restApiStackParamsJson) {
      const params = JSON.parse(restApiStackParamsJson);
      setFullDomainName(params.FullDomainName || "");
      setBackendApiHostname(params.BackendApiHostname || "");
      setExcludeStageFromPath(params.ExcludeStageFromPath === "True" || false);
      setGenericCertificateArn(params.GenericCertificateArn || "");
      setLogRetentionDays(params.LogRetentionDays || "");
    }
  }, [restApiStackParamsJson]);

  return (
    <>
      <PageLoading loading={loading} />
      <Grid container spacing={2} sx={{ flexGrow: 1 }}>
        <Grid xs={12}>
          <Typography level="body-sm" sx={{ py: 1 }}>
            CloudFormation stack status: {restApiStackStatus || "Not deployed"}
          </Typography>
        </Grid>
        <Grid xs={12} sm={6}>
          <FormControl>
            <FormLabel>Full Domain Name</FormLabel>
            <Input
              disabled={true}
              value={fullDomainName}
              onChange={(event) => {
                setFullDomainName(event.target.value);
              }}
            />
            <FormHelperText>The full domain name of deployment.</FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6}>
          <FormControl>
            <FormLabel>Backend API Hostname</FormLabel>
            <Input
              disabled={true}
              value={backendApiHostname}
              onChange={(event) => {
                setBackendApiHostname(event.target.value);
              }}
            />
            <FormHelperText>
              The backend API hostname of deployment.
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6}>
          <FormControl>
            <FormLabel>Exclude Stage From Path</FormLabel>
            <Typography
              component="label"
              startDecorator={
                <Switch
                  checked={excludeStageFromPath}
                  onChange={(event) => {
                    setExcludeStageFromPath(event.target.checked);
                  }}
                />
              }
            >
              {excludeStageFromPath ? "Yes" : "No"}
            </Typography>
            <FormHelperText>
              If true, the stage name will be excluded from the path.
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6}>
          <FormControl>
            <FormLabel>SSL Certificate ARN</FormLabel>
            <Input
              disabled={true}
              value={genericCertificateArn}
              onChange={(event) => {
                setGenericCertificateArn(event.target.value);
              }}
            />
            <FormHelperText>
              The generic SSL certificate ARN of the deployment.
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6}>
          <FormControl>
            <FormLabel>Log Retention Days</FormLabel>
            <Input
              disabled={true}
              value={logRetentionDays}
              onChange={(event) => {
                setLogRetentionDays(event.target.value);
              }}
            />
            <FormHelperText>
              The log retention days of the deployment.
            </FormHelperText>
          </FormControl>
        </Grid>
      </Grid>
    </>
  );
};
